import GroupIcon from "@mui/icons-material/Group";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
// import FriendModal from "src/popup/components/FriendModal/FriendModal";
import { useRouter } from "../../hooks/useRouter";
import { ROUTES } from "../../routes";
import { createClickEngagementRecorder } from "../../utils/api";
import { useWhiteboardRoom } from "../../hooks/useWhiteboardRoom";
import { useLocation } from 'react-router-dom';

const SocialConnection = () => {
  const location_route = useLocation();
  const { t } = useTranslation();
  const { push, location } = useRouter();
  const { roomDomain } = useWhiteboardRoom();
  const clickRecorder = createClickEngagementRecorder(roomDomain, roomDomain);
  const handleBtnClick = () => {
    clickRecorder("menu-friend");
    push(ROUTES.FRIEND_PAGE, location_route.search);
  };
  const isActive =
    location.pathname === ROUTES.FRIEND_PAGE ||
    location.state?.from === ROUTES.FRIEND_PAGE;

  return (
    <Tooltip
      title={t("SocialConnection_Friend_List")}
      placement="bottom"
      arrow
      disableInteractive
    >
      <IconButton
        aria-label="invite"
        onClick={handleBtnClick}
        color={isActive ? "primary" : "default"}
      >
        <GroupIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default SocialConnection;
